import React from 'react';

import { APP_NAME_BRAND } from 'utils/constants';
import StorageService from 'utils/storage';

import LogoWhite from 'img/logo_white.png';
import ExchangeLogoWhite from 'img/exchange.logo_white.png';
import { ReactComponent as InstagramIcon } from 'img/icons/instagram.svg';
import { ReactComponent as FacebookIcon } from 'img/icons/facebook.svg';
import YoutubeIcon from 'img/icons/youtube.png';

export default function LandingFooter() {
  const navigation = StorageService.get('userData')?.full_name
    ? [
        { name: 'Blog', href: '#' },
        { name: 'Operaciones', href: '/my_operations' },
      ]
    : [
        { name: 'Blog', href: '#' },
        { name: 'Iniciar sesión', href: '/login' },
        { name: 'Crear cuenta', href: '/signup' },
      ];

  return (
    <footer className="mt-32 border-t border-gray-200 bg-primary-600">
      <div className="mx-auto max-w-7xl overflow-hidden py-16 px-6 lg:px-8">
        <img
          src={process.env.REACT_APP_LOGO === 'exchange' ? ExchangeLogoWhite : LogoWhite}
          className="xs:h-20 mx-auto h-16 md:h-24"
          alt=""
        />
        <nav
          className="-mb-6 mt-6 flex columns-2 justify-center space-x-6 sm:space-x-12"
          aria-label="Footer"
        >
          {navigation.map((item) => (
            <div key={item.name} className="pb-6">
              <a
                href={item.href}
                className="text-base leading-6 text-gray-100 hover:text-gray-600 hover:underline"
              >
                {item.name}
              </a>
            </div>
          ))}
        </nav>
        <div className="mt-10 flex justify-center space-x-10">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex h-8 w-8 items-center justify-center rounded-full bg-white"
          >
            <span className="sr-only">Instagram</span>
            <InstagramIcon className="h-4.5 w-4.5" aria-hidden="true" />
          </a>
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex h-8 w-8 items-center justify-center rounded-full bg-white"
          >
            <span className="sr-only">Facebook</span>
            <FacebookIcon className="h-5 w-5" aria-hidden="true" />
          </a>
          <a href="/" target="_blank" rel="noreferrer">
            <img src={YoutubeIcon} className="h-8 rounded-full bg-blue-900" alt="" />
          </a>
        </div>
        <p className="mt-10 text-center text-xs leading-5 text-gray-100">
          &copy; 2023 {APP_NAME_BRAND}
        </p>
      </div>
    </footer>
  );
}
